<template>
  <div>
    <div>
      <el-descriptions
        border
        size="small"
        :column="2"
        :labelStyle="{ width: '100px' }"
      >
        <el-descriptions-item
          :label="$l('form_label_ncNo') || 'NC编号'"
          :contentStyle="{ width: '300px' }"
        >
          {{ formData.ncNo || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_identifyGoodsNo') || '产品识别号'"
        >
          {{ formData.identifyGoodsNo || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_orderGoodsDisplayName') || '产品名称'"
        >
          {{ formData.orderGoodsDisplayName || '' }}
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        border
        size="small"
        class="bottom-desc"
        :column="1"
        :labelStyle="{ width: '100px' }"
      >
        <el-descriptions-item
          :label="$l('form_label_orderGoodsSpecDetail') || '规格尺寸'"
        >
          <span v-if="formData.v_isGroup" class="mr-2">
            <el-tag
              size="mini"
              :type="formData.isGroup == 'Y' ? 'warning' : ''"
            >
              {{ formData.v_isGroup }}
            </el-tag>
          </span>
          <span>{{ formData.orderGoodsSpecDetail || '' }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        border
        size="small"
        class="bottom-desc"
        :column="5"
        :contentStyle="{ width: '128px' }"
      >
        <el-descriptions-item
          :label="$l('form_label_fabricCost') || '面料成本'"
        >
          {{ fabricCost }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_materialCost') || '辅料成本'"
        >
          {{ materialCost }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_laborCost') || '人工成本'">
          {{ laborCost }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_packingCost') || '包装成本'"
        >
          {{ packingCost }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_otherCost') || '其他费用'">
          {{ otherCost }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_totalCostAmount') || '不含税成本'"
        >
          {{ totalCostAmount }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_managementFee') || '管理费'"
        >
          {{ managementFee }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_profit') || '毛利'">
          {{ profit }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_vat') || '增值税'">
          {{ vat }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_quote') || '含税成本'">
          {{ quote }}
        </el-descriptions-item>
      </el-descriptions>
      <GoodsPackingTable
        ref="goodsPackingTable"
        class="mt-2"
        :disabled="disabled"
        :pdCostsOrderGoodsCode="pdCostsOrderGoodsCode"
        @reload="getData"
      />
      <GoodsOtherfeesTable
        ref="goodsOtherfeesTable"
        class="mt-2"
        :disabled="disabled"
        :pdCostsOrderGoodsCode="pdCostsOrderGoodsCode"
        @reload="getData"
      />
    </div>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import GoodsPackingTable from '../goods-packing'
import GoodsOtherfeesTable from '../goods-otherfees'
import { format } from '@/libs/util.number.js'
export default {
  components: { GoodsPackingTable, GoodsOtherfeesTable },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    pdCostsOrderGoodsCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      loading: false,
    }
  },
  computed: {
    fabricCost() {
      return format(this.formData.fabricCost)
    },
    materialCost() {
      return format(this.formData.materialCost)
    },
    laborCost() {
      return format(this.formData.laborCost)
    },
    packingCost() {
      return format(this.formData.packingCost)
    },
    otherCost() {
      return format(this.formData.otherCost)
    },
    totalCostAmount() {
      return format(this.formData.totalCostAmount)
    },
    managementFee() {
      return format(this.formData.managementFee)
    },
    profit() {
      return format(this.formData.profit)
    },
    vat() {
      return format(this.formData.vat)
    },
    quote() {
      return format(this.formData.quote)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.pdCostsOrderGoodsCode) return
      this.loading = true
      const res = await this.$api
        .pdCostsOrderGoodsDetailApi({
          pdCostsOrderGoodsCode: this.pdCostsOrderGoodsCode,
        })
        .catch(() => null)
      this.loading = true
      if (!res || !res.body) return
      this.formData = res.body
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  // .order-goods-display-name {
  //   padding: 0 !important;
  //   div {
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;
  //     span {
  //       padding: 8px 10px;
  //     }
  //     span:last-child {
  //       // width: 200px;
  //       border-left: 1px solid #ebeef5;
  //     }
  //   }
  // }
}
</style>
